import { Pipe, PipeTransform } from '@angular/core'
import { stueckGesamtText, Verpackungsangabe, verpackungseinheitText } from '../util/verpackungseinheit.util'

/** „Packung mit 20 Stück" bzw. „24 Stück je Einheit". Regeln: `verpackungseinheit.util.ts`. */
@Pipe({ name: 'verpackungseinheit' })
export class VerpackungseinheitPipe implements PipeTransform {
  transform(produkt: Verpackungsangabe | null | undefined): string | undefined {
    return verpackungseinheitText(produkt)
  }
}

/** `produkt | stueckGesamt: menge` ergibt „72 Stück", oder `undefined`, wenn die Menge schon Stück zählt. */
@Pipe({ name: 'stueckGesamt' })
export class StueckGesamtPipe implements PipeTransform {
  transform(produkt: Verpackungsangabe | null | undefined, menge: number | null | undefined): string | undefined {
    return stueckGesamtText(produkt, menge)
  }
}
